<template>
  <section class="products-section">
    <div class="container">
      <!-- Tab切换分类导航 -->
      <div class="category-tabs-container">
        <div class="category-tabs" ref="categoryTabsRef">
          <div
              v-for="category in categories"
              :key="category.foreignId"
              :class="['category-tab-item', {'active': menuId === category.foreignId}]"
              @click="handleCategoryClick(category)">
            {{ category.name }}
          </div>
        </div>
        <div class="arrow-left" @click="scrollTabs('left')" v-show="showLeftArrow">
          <i class="el-icon-arrow-left"></i>
        </div>
        <div class="arrow-right" @click="scrollTabs('right')" v-show="showRightArrow">
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>

      <!-- 页面诏告栏 -->
      <div class="page-alert">
        <div class="page-alert-lf">
          <img v-lazy="currentTable.coverImg" :alt="currentTable.name" />
        </div>
        <div class="page-alert-rt">
          <div class="alert-title" >
            {{ currentTable.name }}
          </div>
          <div class="alert-desc">
            {{ currentTable.description }}
          </div>
        </div>
      </div>

      <!-- 产品表格 -->
      <!--酶类产品生产数据展示区域-->
      <div class="products-container" v-loading="loading" element-loading-text="加载中..." >
        <el-table
            :data="filteredProducts"
            style="width: 100%"
            @row-click="handleProductClick">
          <el-table-column
              show-overflow-tooltip
              v-for="(item, index) in tableTitles"
              :label="item.label"
              :key="index">
            <template #default="scope">
              <div class="product-name">{{ getCellValue(scope.row, index) }}</div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 分页器 -->
    <div v-if="filteredProducts.length > 0" class="pagination-section">
      <div class="pagination-wrapper container">
        <Pagination
            :total="total"
            :page-size="pageSize"
            :current-page="currentPage"
            @current-change="handlePageChange"
        />
      </div>
    </div>
  </section>
</template>

<script>
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import { getProductCategory} from '@/api/products'
import {mapState} from "vuex";
import Pagination from '@/components/Pagination.vue'
import {pushWithLanguage} from "@/utils/routeUtils";

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'ProductsListM',
  components: {
    Pagination
  },

  data() {
    return {
      bannerBg: 'https://file.yacoo.com.cn/staticResource/products/products-header-bg.webp?x-oss-process=image/resize,h_480',
      searchKeyword: '',
      categories: [], // 所有分类数据
      filteredProducts: [],
      tableTitles: [],
      menuId: '2',
      categoryInfo: null,
      pageSize: 10,
      loading: false,
      currentTable: {},
      productQuery: {
        productId: '',
        name: '',
        parentId: '',
        parentName: ''
      },
      showLeftArrow: false,
      showRightArrow: false
    }
  },

  props: {
    parentId: {
      type: String,
      default: '2'
    },
    products: {
      type: Array,
      default: () => []
    },
    total: {
      type: Number,
      default: 0
    },
    selectedCategory: {
      type: String,
      default: ''
    },
    currentPage: {
      type: Number,
      default: 1
    }
  },

  computed: {
    currentCategory() {
      return this.categories.find(cat => cat.foreignId === this.menuId) || null
    },
    ...mapState({
      currentLanguage: state => state.app.language
    })
  },

  watch: {
    selectedCategory: {
      handler(newVal, oldVal) {
        // 监听分类变化
        this.menuId = newVal
        console.log('selectedCategory', newVal,'========')
        // 滚动选中的标签到可见区域
        this.$nextTick(() => {
          this.scrollSelectedTabIntoView()
        })
      }
    },
    products: {
      handler(newVal, oldVal) {
        this.filteredProducts = newVal
        this.initAnimations()
      },
      immediate: true
    },
    categories: {
      handler() {
        this.$nextTick(() => {
          this.checkTabsOverflow()
        })
      }
    },
    currentLanguage: {
      handler() {
        this.getCategories()
      }
    }
  },

  created() {
    // 获取分类数据
    this.getCategories()

  },

  mounted() {
    window.addEventListener('resize', this.checkTabsOverflow)
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.checkTabsOverflow)
  },

  methods: {
    async getCategories() {
      try {
        const response = await getProductCategory({parentId: Number(this.parentId)})
        if (response.success) {
          this.categories = response.data
          this.currentTable = this.categories[0]
          this.tableTitles = this.categories[0].tableTitles
          // 默认选择第一个分类
          if (this.categories.length > 0) {
            this.menuId = this.categories[0].foreignId
            //传递给父组件
            this.$emit('getSelectedCategory', this.menuId)
          }
          // 检查是否需要显示箭头
          this.$nextTick(() => {
            this.checkTabsOverflow()
          })
        } else {
          this.$message.error(response.msg || '获取产品分类失败')
        }
      } catch (error) {
        console.error('获取产品分类失败:', error)
        this.$message.error('获取产品分类失败，请稍后重试')
      }
    },

    handleCategoryClick(category) {
      this.menuId = category.foreignId
      this.currentTable = category
      this.tableTitles = category.tableTitles
      //传递给父组件
      this.$emit('getSelectedCategory', this.menuId)
    },

    getCellValue(row, index) {
      const module = row && row.module
      const content = module && Array.isArray(module.content) ? module.content[index] : null
      const firstChild = content && Array.isArray(content.children) ? content.children[0] : null
      return firstChild && firstChild.value ? firstChild.value : '--'
    },

    handleProductClick(row) {
      return
      pushWithLanguage(`/products/${row.id}` , this.currentLanguage).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error(err)
        }
      })
    },

    handlePageChange(page) {
      this.$emit('pageChange', page)
    },

    initAnimations() {

      // 表格动画
      this.$nextTick(() => {
        gsap.from('.el-table', {
          opacity: 1,
          y: 0,
          duration: 0.5,
          scrollTrigger: {
            trigger: '.products-container',
            start: 'top 80%',
            once: true
          }
        })
      })
    },

    // 检查选项卡是否溢出
    checkTabsOverflow() {
      const tabsContainer = this.$refs.categoryTabsRef
      if (!tabsContainer) return

      // 判断是否有溢出
      const isOverflowing = tabsContainer.scrollWidth > tabsContainer.clientWidth

      // 显示/隐藏箭头
      this.showRightArrow = isOverflowing && tabsContainer.scrollLeft < (tabsContainer.scrollWidth - tabsContainer.clientWidth)
      this.showLeftArrow = isOverflowing && tabsContainer.scrollLeft > 0
    },

    // 滚动选项卡
    scrollTabs(direction) {
      const tabsContainer = this.$refs.categoryTabsRef
      if (!tabsContainer) return

      const scrollAmount = 300 // 每次滚动的像素数

      if (direction === 'left') {
        tabsContainer.scrollBy({ left: -scrollAmount, behavior: 'smooth' })
      } else {
        tabsContainer.scrollBy({ left: scrollAmount, behavior: 'smooth' })
      }

      // 更新箭头状态
      setTimeout(() => {
        this.checkTabsOverflow()
      }, 300)
    },

    // 将选中的选项卡滚动到可见区域
    scrollSelectedTabIntoView() {
      const tabsContainer = this.$refs.categoryTabsRef
      if (!tabsContainer) return

      const activeTab = tabsContainer.querySelector('.category-tab-item.active')
      if (activeTab) {
        // 计算需要滚动的位置，使选中的标签位于最左侧
        const containerLeft = tabsContainer.getBoundingClientRect().left
        const tabLeft = activeTab.getBoundingClientRect().left
        const scrollOffset = tabLeft - containerLeft

        tabsContainer.scrollLeft += scrollOffset

        // 更新箭头状态
        setTimeout(() => {
          this.checkTabsOverflow()
        }, 300)
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/styles/variables.less';
@import '@/assets/styles/mixins.less';
  .products-section {
    padding: 35px 0 0 0;
    background: #fff;

    .container {
      max-width: 1520px;
      margin: 0 auto;
      padding: 0;
    }

    .page-alert{
      display: flex;
      min-height: 253px;
      overflow: hidden;
      width: 100%;
      gap: 45px;
      background: #F1F3F5;
      margin-bottom: 30px;
      .page-alert-lf {
        width: 478px;
        height: 100%;
        display: flex;
        align-items: center;
        overflow: hidden;
        flex-shrink: 0;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .page-alert-rt {
        flex: 1;
        padding: 20px 0;
        .alert-title {
          font-weight: 600;
          font-size: 48px;
          color: #19529F;
          line-height: 67px;
          text-align: left;
          font-style: normal;
          text-transform: none;
          margin-bottom: 20px;
          position: relative;
          &:after {
            content: '';
            position: absolute;
            bottom: -5px;
            left: 0;
            width: 113px;
            height: 7px;
            background: linear-gradient( 270deg,rgba(226, 110, 118, 0) 0%, rgba(226, 110, 118, .2) 35%, #19529F 100%);
          }
        }
        .alert-desc {
          font-weight: 400;
          font-size: 20px;
          color: #7A7A7A;
          line-height: 35px;
          text-align: justify;
          font-style: normal;
          padding-right: 20px;
        }
      }
    }
    .category-tabs-container {
      position: relative;
      margin-bottom: 20px;
      overflow: hidden;

      .category-tabs {
        display: flex;
        overflow-x: auto;
        scroll-behavior: smooth;
        padding: 10px 0;
        -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;  /* Firefox */

        &::-webkit-scrollbar {
          display: none; /* Chrome, Safari, Opera */
        }
      }

      .category-tab-item {
        min-width: 244px;
        height: 78px;
        border-radius: 8px;
        padding: 0 20px;
        flex: 0 0 auto;
        background: #E0E4E9;
        margin-right: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        color: #333;
        font-size: 32px;
        transition: all 0.3s;

        &.active {
          background: linear-gradient( 324deg, #E26E76 0%, #19529F 100%);
          color: #fff;

        }

        &:last-child {
          margin-right: 0;
        }
      }

      .arrow-left, .arrow-right {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.9);
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        z-index: 10;

        i {
          font-size: 20px;
          color: #333;
        }

        &:hover {
          background: #fff;
        }
      }

      .arrow-left {
        left: 0;
      }

      .arrow-right {
        right: 0;
      }
    }

    .products-container {
      width: 100%;

      :deep(.el-table) {
        overflow: visible;
        .product-name {
          font-size: 20px;

          color: #333;
          margin-bottom: 5px;
        }
        .product-chemical-name {
          font-size: 20px;
          color: #666;
        }
        .el-table__header{
          .cell {
            padding: 0 50px;
            font-size: 24px;
          }
        }
        .el-table__header-wrapper th{
          height: 107px;
        }

        .el-table__row {
          .cell {
            padding: 0 50px;
          }

          td{
            height: 81px;
          }
        }
      }

      :deep(.el-table__header-wrapper) {
        background: #fff;
        box-shadow: 0px 2px 20px 0px rgba(0,0,0,0.19);
        border-radius: 4px 4px 0 0;
        z-index: 2;
        position: relative;
      }
      :deep(.el-table__header-wrapper th) {
        background: transparent !important;
        height: 80px;
        color: #333;
        font-weight: 600;
        padding: 0;
        font-size: 18px;
      }

      :deep(td) {
        padding: 15px 0;
      }
      :deep(tr:hover) {
        cursor: pointer;
        background-color: #F5F7FA;
      }
    }

    .pagination-section{
      background-color: rgba(185, 194, 205, .2);
      padding: 42px;
      margin-top: 30px;
    }

    .pagination-wrapper {
      padding-left: 20%;
    }

    .no-data {
      text-align: center;
      padding: 40px 0;
      color: #999;
      font-size: 14px;
    }
  }
</style>